import React from 'react'
import styled from 'styled-components'
import {
  headerBlackStyle,
  listDropStyle,
  magicContainerFullStyle,
  text1GrayStyle,
} from '../styled'
import LinkGetStarted from '../LinkGetStarted'

import Image from '../../Image'
import mediaQuery from 'styles/mediaQuery'

const Section = styled.section`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  ${mediaQuery.tabletMax} {
    padding: 24px 16px;
  }
  ${mediaQuery.bigTabletMin} {
    padding: 60px 90px 55px 78px;
  }
  ${mediaQuery.desktopMin} {
    padding: 120px 157px 110px 233px;
    height: 600px;
  }
`

const Container = styled.div`
  ${magicContainerFullStyle};
  background-color: #fff;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  gap: 30px;
  ${mediaQuery.bigTabletMin} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 56px;
  }
`

const TextWrapper = styled.div`
  width: 440px;
  max-width: 100%;
`

const Title = styled.h2`
  ${headerBlackStyle};
  margin-bottom: 24px;
  ${mediaQuery.mobile} {
    margin-bottom: 16px;
  }
`

const ListStyle = styled.ul`
  ${text1GrayStyle};
  margin-bottom: 24px;
  & > li {
    ${text1GrayStyle};
    ${listDropStyle};
    display: flex;
    position: relative;
    padding-left: 15px;
    margin-left: 8px;
  }
`

const ImageStyled = styled(Image)`
  width: 100%;
  max-width: 520px;
`

const translations = {
  header: 'Who is it for?',
  description: [
    'Direct to consumer brands, not resellers',
    'Qualified US brands',
  ],
  linkLabel: 'Get started',
}

const HomeForWhoIs = () => (
  <Section id="forWhoIs">
    <Container>
      <TextWrapper>
        <Title>{translations.header}</Title>
        <ListStyle>
          {translations.description.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ListStyle>
        <LinkGetStarted linkLabel={translations.linkLabel} />
      </TextWrapper>
      <ImageStyled fileName="newMagic/img2.png" alt={translations.header} />
    </Container>
  </Section>
)

export default HomeForWhoIs
